import store from "fragments/vendors/store"
import { gql } from "graphql-tag"

const GET_STORE_BY_ID = gql`
  ${store}

  query getStoreById($id: ID!) {
    getStoreById(id: $id) {
      ...Store
    }
  }
`

export default GET_STORE_BY_ID
